import $ from 'jquery';

function turnOnFullscreenMode(): void {
    const isFullScreenModeAvailable = document.fullscreenEnabled;
    if (isFullScreenModeAvailable) {
        const iframe = document.querySelector('#gameIframe') as HTMLIFrameElement;
        iframe.requestFullscreen();
    }
}

$('.iframeFullScreen').on('click', () => {
    if (/iPad|iPhone/.test(navigator.userAgent)) {
        $('#gameIframe').closest('.iframe-container').addClass('iOS');
        $('.page-footer, .topbar, .container-fluid:not(.game-play)').hide();
        $('#app').css('margin-top', '0');
    } else {
        turnOnFullscreenMode();
    }
});

$(function () {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
        const headerHeight = $('header').height() !== 0 ? $('header').height() : $('header .container-fluid').height();

        $('.iframe-container').css({
            height: $(window).height() - headerHeight,
        });
    }
});
